import React from 'react'
import PropTypes from 'prop-types'

import { YES_NO_OPTIONS } from 'utils/enums/questions'
import { FormRadioButtonGroup } from 'components/form/radioButtonGroup/FormRadioButtonGroup'
import { validateRequiredField } from 'utils/helpers/validators/byType/requiredField'

import styles from '../FormByState.module.scss'

export const AZFormConfig = {
  wasApplicantReliable: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  hadPerformanceIssues: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  hadDisciplinaryAction: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wouldRehire: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  hadReasonNotWorkWithChildren: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
}

export const AZForm = ({ formData, handleFieldChange }) => (
  <div className={styles.form}>
    <FormRadioButtonGroup
      title="Was the applicant’s attendance and punctuality reliable?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasApplicantReliable}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Were there any performance concerns?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.hadPerformanceIssues}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Was disciplinary action ever taken or were there any conduct concerns?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.hadDisciplinaryAction}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Would you rehire this person?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wouldRehire}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Do you know of any reason why the person should not work with children?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.hadReasonNotWorkWithChildren}
      handleFieldChange={handleFieldChange}
    />
  </div>
)

AZForm.propTypes = {
  formData: PropTypes.object.isRequired,
  formMeta: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
